<template>
  <div class="abs-pa" >

    <div class="row">
        <div class="col s6">
            <el-form-item :label="$teras.lang.cognome"  prop="prcognome">
                <el-input  v-model="$abs.row.prcognome"></el-input>
            </el-form-item>
        </div>
        <div class="col s6" >
            <el-form-item :label="$teras.lang.nome" prop="prnome">
                <el-input  v-model="$abs.row.prnome"></el-input>
            </el-form-item>
        </div>
    </div>


    <div class="row">
        <div class="col s6" >
            <el-form-item :label="$teras.lang.email" prop="premail">
                <el-input  v-model="$abs.row.premail"></el-input>
            </el-form-item>
        </div>
        <div class="col s6">
            <el-form-item :label="$teras.lang.cellulare">
                <el-input  v-model="$abs.row.prcellulare"></el-input>
            </el-form-item>
        </div>
    </div>   

<div class="col s12 m10 offset-m2">
  <h4 class="yo-color-secondary">{{$teras.lang.privacyTitle}}</h4>
  <div v-if="$teras.language=='it'">
  Si prega di prendere visione dell'Informativa sul Trattamento dei Dati <a target="_blank" :href="'https://bvent.biomedia.net/gdpr/privacy-ABSTRACT'+($teras.evento.id==136 ? '-'+$teras.evento.id : '')+'.pdf'" >cliccando qui</a>
  </div>
  <div v-if="$teras.language=='en'">
  Please <a target="_blank" href="https://bvent.biomedia.net/gdpr/privacy-ABSTRACT-en.pdf">view</a> Privacy Policy
  </div>
  
</div>

  </div>
</template>

<script>

export default {
  name: 'abs-primoautore',
  components: {
  },
  created () {
    console.log("Arrivo al abs-primoautore.vue");
  },
  data() {
    return {
      options: {},
      autore:{
        id:-1,
        cognome: '',
        nome: '',
        affiliazione:''
      },
    }
  },
  computed:{
    annonascita: function(){
        var year = new Date().getFullYear()
        var arr = []
        for(var i = year-82; i <= year-18; i++) 
            arr.push(i)
        return arr
    }

  },
  methods: {
    affiliazione(id){
        for ( const affiliazione of this.$teras.affiliazioni){
            //console.log(affiliazione)
            if(affiliazione.id == id){
            return this.$teras.affiliazioni.indexOf(affiliazione)+1
            }
        }
        return $teras.lang.errore
      },
    onEnd(){
    },
    onEdit(autore){
      this.autore.id=autore.id
      this.autore.cognome=autore.cognome
      this.autore.nome=autore.nome
      this.autore.affiliazione=autore.affiliazione
    },
    delNow(){
      for ( const autore of this.$teras.autori){
        //console.log(autore)
        if(autore.id == this.autore.id){
          console.log(this.$teras.autori.indexOf(autore))
          this.$teras.autori.splice(this.$teras.autori.indexOf(autore),1)
          this.reset()
        }
      }
    },
    addNow(){
      this.autore.id = this.$teras.autori.length
      this.$teras.autori.push({id:this.autore.id,cognome:this.autore.cognome,nome:this.autore.nome,affiliazione:this.autore.affiliazione})
      this.reset()
    },
    editNow(){
      for (let autore of this.$teras.autori)
        if(autore.id == this.autore.id){
          autore.cognome=this.autore.cognome
          autore.nome=this.autore.nome
          autore.affiliazione=this.autore.affiliazione
        }
      this.reset()
    },
    reset(){
      this.autore.id=-1
      this.autore.cognome=''
      this.autore.nome=''
      this.autore.affiliazione = ''
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// Abs-presentatore.vue?08a393a6